import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  NumberInputProps,
} from "@chakra-ui/react";
import { useController, Control, FieldValues, Path } from "react-hook-form";

interface FormNumberInputProps<T extends FieldValues>
  extends Omit<NumberInputProps, "name"> {
  name: Path<T>;
  label: string;
  control: Control<T, any, any>;
  isRequired?: boolean;
}

export function FormNumberInput<T extends FieldValues>({
  name,
  label,
  control,
  isRequired = false,
  ...numberInputProps
}: FormNumberInputProps<T>) {
  const {
    field: { ref, value, onChange, ...field },
    fieldState: { error },
  } = useController({
    name,
    control,
  });

  return (
    <FormControl isInvalid={!!error} isRequired={isRequired}>
      <FormLabel>{label}</FormLabel>
      <NumberInput
        onChange={(_: string, valueAsNumber: number) => onChange(valueAsNumber)}
        value={value}
        {...field}
        {...numberInputProps}
        inputMode="none"
      >
        <NumberInputField ref={ref} />
        <NumberInputStepper>
          <NumberIncrementStepper />
          <NumberDecrementStepper />
        </NumberInputStepper>
      </NumberInput>
      <FormErrorMessage>{error?.message}</FormErrorMessage>
    </FormControl>
  );
}
